import React, { useContext, type ReactNode, createContext } from 'react';
import { type FedopsLogger } from '@wix/fedops-logger';
import { type InteractionName } from '../../../types/InteractionName';

export type WidgetFedopsLogger = FedopsLogger<InteractionName>;
export interface Props {
  fedopsLogger: FedopsLogger<InteractionName>;
  children: ReactNode;
}

export const FedopsContext = createContext<WidgetFedopsLogger>(null);

export const FedopsProvider = (props: Props) => (
  <FedopsContext.Provider value={props.fedopsLogger}>{props.children}</FedopsContext.Provider>
);

export const useFedopsLogger = (): WidgetFedopsLogger => useContext(FedopsContext);
